var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_3297)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5769 4.1665C29.5493 4.16671 30.4818 4.55316 31.1693 5.24084L37.4283 11.4998C38.116 12.1873 38.5024 13.1198 38.5026 14.0922V29.8332C38.5026 30.8056 38.1163 31.7383 37.4287 32.4259C36.741 33.1135 35.8084 33.4998 34.8359 33.4998H31.1693V37.1665C31.1693 38.139 30.783 39.0716 30.0953 39.7592C29.4077 40.4469 28.4751 40.8332 27.5026 40.8332H11.0026C10.0301 40.8332 9.09751 40.4469 8.40988 39.7592C7.72225 39.0716 7.33594 38.139 7.33594 37.1665V15.1665C7.33594 14.194 7.72225 13.2614 8.40988 12.5738C9.09751 11.8861 10.0301 11.4998 11.0026 11.4998H14.6693V7.83317C14.6693 6.86071 15.0556 5.92808 15.7432 5.24045C16.4308 4.55281 17.3635 4.1665 18.3359 4.1665H28.5769ZM14.6693 15.1665H11.0026V37.1665H27.5026V33.4998H18.3359C17.3635 33.4998 16.4308 33.1135 15.7432 32.4259C15.0556 31.7383 14.6693 30.8056 14.6693 29.8332V15.1665ZM25.6693 7.83317H18.3359V29.8332H34.8359V16.9998H28.4193C27.7357 16.9998 27.0766 16.7452 26.5705 16.2855C26.0645 15.8259 25.7477 15.1943 25.6821 14.5138L25.6693 14.2498V7.83317ZM29.3359 8.59217V13.3332H34.0769L29.3359 8.59217Z",
    fill: "#192BC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_3297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.c6b4d3edcfe264456a47903b716be0f1.svg";
export { ForwardRef as ReactComponent };